<script lang="ts">
	import { onMount } from 'svelte';
	import { trackJm } from '$lib/utils/juiceMedia';
	import { useStoryblokBridge } from '@storyblok/js';
	import Blok from '$lib/storyblok/blok.svelte';

	let { data } = $props();

	onMount(() => {
		trackJm('homepage_view');

		useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory));
	});
</script>

<svelte:head>
	<title>{data.story.content.seo?.title || 'Home'}</title>
	<meta name="description" content={data.story.content.seo?.description || ''} />
</svelte:head>

<Blok content={data.story.content} />
